<a class="a-tag a-tag--small {{class}} {{ modifier && 'a-tag--' + modifier || modifier }} {{ icon && 'a-tag__icon-' + icon || icon }}">
	{{text}}
</a>
